<div class="modal-header">
  <h3 class="modal-title">Ansprechpartner</h3>
</div>

<form class="form-horizontal" [formGroup]="form" (ngSubmit)="save()">

  @if (!change) {
    <div class="modal-body">
      <div class="row border-bottom">
        <div class="col-sm-9">
          <div class="row">
            <div class="col-sm-12">
              {{ contact.title }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <h4>{{ contact.first_name }}&nbsp;{{ contact.last_name }}</h4>
            </div>
          </div>
          <div class="row"><div class="col-sm-12">&nbsp;</div></div>
          @if (contact.departments.length > 0) {
            <div class="row">
              <div class="col-sm-2">Abteilung:</div>
              <div class="col-sm-10">{{ contact.departments|JoinStringPipe }}</div>
            </div>
          }
          @if (contact.position) {
            <div class="row">
              <div class="col-sm-2">Position:</div>
              <div class="col-sm-10">{{ contact.position }}</div>
            </div>
          }
        </div>
        <div class="col-sm-3">
          <img style="height: 100px;" src="/ui/assets/images/contact_opancy.png">
        </div>
      </div>
      <div class="row border-bottom">
        <div class="col-sm-9">
          <h4>Kontakt</h4>
          @if (contact.phone) {
            <div class="row">
              <div class="col-sm-2">Telefon:</div>
              <div class="col-sm-10">{{ contact.phone }}</div>
            </div>
          }
          @if (contact.fax) {
            <div class="row">
              <div class="col-sm-2">Fax:</div>
              <div class="col-sm-10">{{ contact.fax }}</div>
            </div>
          }
          @if (contact.mobile) {
            <div class="row">
              <div class="col-sm-2">Mobil:</div>
              <div class="col-sm-10">{{ contact.mobile }}</div>
            </div>
          }
          @if (contact.mail) {
            <div class="row">
              <div class="col-sm-2">E-Mail:</div>
              <div class="col-sm-10">{{ contact.mail }}</div>
            </div>
          }
        </div>
      </div>
      <div class="col-sm-3">
      </div>
      @if (contact.note) {
        <div class="row">
          <div class="col-sm-9">
            <h4>Hinweis</h4>
            <strong>{{contact.note}}</strong>
          </div>
        </div>
      }
    </div>
  }


  @if (change) {
    <div class="modal-body">
      <customer-contact-form [form]="form" [departments]="departments"></customer-contact-form>
    </div>
  }

  <div class="modal-footer">
    @if (!change) {
      <button type="button" class="btn btn-default float-left" (click)="dismiss()">Abbrechen</button>
    }
    @if (change) {
      <button type="button" class="btn btn-default float-left" (click)="toggle()">Abbrechen</button>
    }

    <div class="btn-group float-right">
      @if (('crm.contact.delete'|HasPerm)) {
        <button class="btn btn-danger" type="button" (click)="deleteContact()">
          <span class="fa fa-trash-o"></span>
        </button>
      }

      @if (!change) {
        <button type="button" class="btn btn-default" (click)="toggle()">
          Ansprechpartner bearbeiten
        </button>
      }
      @if (change) {
        <button type="submit" class="btn btn-default">
          Ansprechpartner speichern
        </button>
      }
    </div>
  </div>
</form>
